/**
 * Accepts a nullable value and returns back undefined if null.
 *
 * This is useful for building up maps of nullable items that get passed to graphQL resolvers
 */
export function coalesceToUndefined<T>(
  value: T | null | undefined
): T | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  return value;
}
